import React from 'react';
import './PageContentHeader.scss';

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

const PageContentHeader = ({
  actions = null,
  actionsClassName = '',
  className = '',
  description = '',
  title,
  titleAs: Title = 'h2',
}) => (
  <div className={joinClassNames('page-content-header', className)}>
    <div className="page-content-header__main">
      <Title>{title}</Title>
      {description && <p>{description}</p>}
    </div>
    {actions && (
      <div className={joinClassNames('page-content-header__actions', actionsClassName)}>
        {actions}
      </div>
    )}
  </div>
);

export default PageContentHeader;
